// extracted by mini-css-extract-plugin
export default {"others-header":"OthersTab_others-header__TQ9wY"};